module.exports = __webpack_public_path__ + "img/thumb_33.7acc1c38.jpg";